import Parse from "parse";

export function getLibraryLullabies() {
  return Parse.Cloud.run("getLibraryLullabies");
}

export async function getLullabies() {
  const lullabies = await Parse.Cloud.run("getLullabies");
  lullabies.forEach((lullaby) => {
    if (lullaby.audioFile) {
      lullaby.audioFile = lullaby.audioFile.toJSON();
    }
  });
  return lullabies;
}

export function addLibraryLullaby(libraryIdentifier) {
  return Parse.Cloud.run("addLibraryLullaby", { libraryIdentifier });
}

export async function addRecordLullaby({ uuid, name, audioFile, duration }) {
  const lullaby = await Parse.Cloud.run("addRecordLullaby", {
    uuid,
    name,
    audioFile,
    duration
  });
  lullaby.audioFile = lullaby.audioFile.toJSON();
  return lullaby;
}

export async function updateRecordLullaby({
  lullabyId,
  name,
  audioFile,
  duration
}) {
  const lullaby = await Parse.Cloud.run("updateRecordLullaby", {
    lullabyId,
    name,
    audioFile,
    duration
  });
  lullaby.audioFile = lullaby.audioFile.toJSON();
  return lullaby;
}

export function removeLullaby(lullabyId) {
  return Parse.Cloud.run("removeLullaby", { lullabyId });
}

export function getLibraryLullabyUrl(libraryIdentifier) {
  return Parse.Cloud.run("getLibraryLullabyUrl", { libraryIdentifier });
}

export function getLullabyUrl(lullabyId) {
  return Parse.Cloud.run("getLullabyUrl", { lullabyId });
}

export async function saveAudioFile(audioData) {
  const parseFile = await new Parse.File(
    "lullabyAudio.ogg",
    Array.from(audioData)
  ).save();
  return parseFile.toJSON();
}
